'use client'

import dynamic from 'next/dynamic'

import { useThemedToast } from '@/src/hooks/ui/useThemedToast'

import { useHotelSearchManager } from './hooks/useHotelSearchManager'

const DesktopHotelSearchForm = dynamic(
    () => import(/* webpackChunkName: "desktop-hotel-search-form" */ './desktopHotelSearchForm'),
    { ssr: true }
)

const MobileHotelSearchForm = dynamic(
    () => import(/* webpackChunkName: "mobile-hotel-search-form" */ './mobileHotelSearchForm/mobileHotelSearchForm'),
    { ssr: true }
)

interface HotelSearchFormProps {
    isMobile: boolean
}

const HotelSearchForm: React.FC<HotelSearchFormProps> = ({ isMobile }) => {
    const searchManager = useHotelSearchManager()
    const { showError } = useThemedToast()

    if (isMobile) {
        return <MobileHotelSearchForm searchManager={searchManager} showError={showError} />
    }

    return <DesktopHotelSearchForm searchManager={searchManager} showError={showError} />
}

export default HotelSearchForm
